#import "../fragments/form-fragment.graphql"

mutation PublishForm($input: FormPublishInput!) {
    formPublish(input: $input) {
        form {
            ...FormFragment
        }
    }
}
